import Link from 'next/link';
import { FC } from 'react';

import { storyblokLink } from '@/helpers/storyblokLink';

import Button from '../Button';
import ButtonArrow from '../ButtonArrow';
import FeaturedPosts from '../FeaturedPosts';
import Heading from '../Heading';
import PreHeading from '../PreHeading';
import Prose from '../Prose';

export interface ServiceMegaMenuProps {
  dropdown: any;
}

function ServiceMenuText({
  pre_heading,
  heading,
  content,
  actions,
  headline,
  pre_headline,
  details,
  page,
  className = '',
}) {
  return (
    <Link
      href={storyblokLink(page)}
      className={`mega-menu mega-menu--solutions group grid gap-8 bg-theme-offwhite transition-colors duration-200 hover:bg-theme-lightgrey/70 lg:grid-cols-[1fr_2fr_auto] ${className} ring-white/20 lg:ring-1`}
    >
      <>
        <div className="space-y-4">
          {(pre_headline || pre_heading) && (
            <PreHeading
              dot={true}
              size="md"
              element="h2"
              color="text-grey"
              className="font-normal"
            >
              {pre_headline || pre_heading}
            </PreHeading>
          )}
          {(headline || heading) && (
            <Heading
              size="2xs"
              weight="semi"
              element={pre_headline ? 'p' : 'h2'}
              className="hidden text-theme-darkgrey lg:inline"
            >
              {headline || heading}
            </Heading>
          )}
          <p className="text-theme-darkgrey">{details}</p>
        </div>
        <div className="mega-menu-content">
          {content && <Prose size={'md'} content={content}></Prose>}
        </div>
        <div>
          {actions && (
            <div className="gap-x-3 text-right duration-200 group-hover:scale-105">
              {actions.map((action) => (
                <Button
                  className={''}
                  key={action._uid}
                  link={action.link}
                  style={action.style}
                >
                  <ButtonArrow
                    className={`${action.style} -ml-1 mr-1 h-5 w-6`}
                  />
                  {action.label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </>
    </Link>
  );
}

const ServiceMegaMenu: FC<ServiceMegaMenuProps> = ({ dropdown }) => {
  return (
    <div>
      <ServiceMenuText {...dropdown} className={'p-0 pb-6 lg:p-10'} />
      <div className="featured-posts border-t-slate-50 bg-theme-lightgrey p-4 md:p-8">
        <FeaturedPosts
          posts={dropdown.featured}
          title={dropdown.featureTitle}
        />
      </div>
    </div>
  );
};

export default ServiceMegaMenu;
